enum Country {
    AT = 'at',
    BE = 'be',
    CY = 'cy',
    CZ = 'cz',
    DE = 'de',
    EE = 'ee',
    ES = 'es',
    FI = 'fi',
    FR = 'fr',
    GR = 'gr',
    IE = 'ie',
    IT = 'it',
    LT = 'lt',
    LU = 'lu',
    LV = 'lv',
    MT = 'mt',
    NL = 'nl',
    PT = 'pt',
    SI = 'si',
    SK = 'sk',
}

// todo: localization!
export const countryOptions = [
    { value: Country.AT.toUpperCase(), text: 'Austria' },
    { value: Country.BE.toUpperCase(), text: 'Belgium' },
    { value: Country.CY.toUpperCase(), text: 'Cyprus' },
    { value: Country.CZ.toUpperCase(), text: 'Czech Republic' },
    { value: Country.DE.toUpperCase(), text: 'Germany' },
    { value: Country.EE.toUpperCase(), text: 'Estonia' },
    { value: Country.FI.toUpperCase(), text: 'Finland' },
    { value: Country.FR.toUpperCase(), text: 'France' },
    { value: Country.GR.toUpperCase(), text: 'Greece' },
    { value: Country.IE.toUpperCase(), text: 'Ireland' },
    { value: Country.IT.toUpperCase(), text: 'Italy' },
    { value: Country.LT.toUpperCase(), text: 'Lithuania' },
    { value: Country.LU.toUpperCase(), text: 'Luxembourg' },
    { value: Country.LV.toUpperCase(), text: 'Latvia' },
    { value: Country.MT.toUpperCase(), text: 'Malta' },
    { value: Country.NL.toUpperCase(), text: 'Netherlands' },
    { value: Country.PT.toUpperCase(), text: 'Portugal' },
    { value: Country.SI.toUpperCase(), text: 'Slovenia' },
    { value: Country.SK.toUpperCase(), text: 'Slovakia' },
    { value: Country.ES.toUpperCase(), text: 'Spain' },
];
